import script from "./CasdoorCallback.vue?vue&type=script&setup=true&lang=js"
export * from "./CasdoorCallback.vue?vue&type=script&setup=true&lang=js"

import "./CasdoorCallback.vue?vue&type=style&index=0&id=3083ccee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3083ccee"]])

export default __exports__